/**
 * SMTP 設定 schema — REQ-20260418010。
 * DB 僅存一組（key='smtp'）；UI / API 皆以這份為 contract。
 */
import { z } from 'zod';

/** 使用者輸入（PUT /api/v1/settings/smtp）。password 留空代表「保留原值」 */
export const SmtpSettingInputSchema = z.object({
  host: z.string().trim().min(1).max(255),
  port: z.coerce.number().int().min(1).max(65535),
  secure: z.boolean().default(false),
  user: z.string().trim().max(255).default(''),
  password: z.string().max(500).default(''),
  fromAddress: z.string().trim().email(),
  fromName: z.string().trim().max(100).default(''),
  enabled: z.boolean().default(true),
});
export type SmtpSettingInput = z.infer<typeof SmtpSettingInputSchema>;

/** API 回傳（不含明文密碼） */
export const SmtpSettingViewSchema = z.object({
  host: z.string(),
  port: z.number().int(),
  secure: z.boolean(),
  user: z.string(),
  hasPassword: z.boolean(),
  fromAddress: z.string().email().or(z.literal('')),
  fromName: z.string(),
  enabled: z.boolean(),
  updatedAt: z.string().datetime().nullable(),
});
export type SmtpSettingView = z.infer<typeof SmtpSettingViewSchema>;

export const SmtpTestResultSchema = z.object({
  ok: z.boolean(),
  message: z.string(),
  messageId: z.string().optional(),
});
export type SmtpTestResult = z.infer<typeof SmtpTestResultSchema>;
